import { useParams, Navigate, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import logoV from './assets/visionary-logo.svg';
import unityLogo from './assets/unity-logo.png';
import footerImg from './assets/blackfield_footer.webp';
import { NEWS } from './news';

export default function ArticlePage() {
  const publisherAuthed = sessionStorage.getItem('bf_gate_auth') === '1';
  const { slug } = useParams();
  const article = NEWS.find(n => n.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) return <Navigate to="/" replace />;

  return (
    <div className="article-page">

      <Helmet>
        <title>{article.title} – Blackfield | Visionary Games</title>
        <meta name="description" content={article.excerpt} />
        <link rel="canonical" href={`https://visionarygames.net/news/${article.slug}`} />
        <meta property="og:title" content={`${article.title} – Blackfield`} />
        <meta property="og:description" content={article.excerpt} />
        <meta property="og:url" content={`https://visionarygames.net/news/${article.slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={article.heroImg} />
        <meta property="og:image:width" content="1920" />
        <meta property="og:image:height" content="1080" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${article.title} – Blackfield`} />
        <meta name="twitter:description" content={article.excerpt} />
        <meta name="twitter:image" content={article.heroImg} />
      </Helmet>

      {/* ── Top Nav ─────────────────────────────────────── */}
      <nav className="top-nav top-nav-solid">
        <div className="top-nav-links">
          <Link to="/" className="top-nav-link top-nav-home">HOME</Link>
          <Link to="/news" className="top-nav-link">NEWS</Link>
          <Link to="/press-kit" className="top-nav-link">PRESS KIT</Link>
          <a href="mailto:yuri@blackfieldgame.com" className="top-nav-link">CONTACT</a>
          <span className="top-nav-link top-nav-disabled">ART BOOK</span>
          <Link to="/publisher" className="top-nav-link top-nav-presentation"><span className="material-symbols-rounded" style={{fontSize:'0.85rem',verticalAlign:'middle'}}>{publisherAuthed ? 'lock_open' : 'lock'}</span> PUBLISHER</Link>
        </div>
      </nav>

      {/* ── Article Content ──────────────────────────────── */}
      <div className="article-wrap">
        <Link to="/news" className="article-back">← BACK TO NEWS</Link>
        <div className="article-meta">
          <span className="news-date">{article.date}</span>
        </div>
        <h1 className="article-title">{article.title}</h1>
        <img src={article.heroImg} alt={article.title} className="article-hero-img" />
        <div className="article-body">
          {article.body.map((section, i) => (
            <div key={i} className="article-section">
              <h3 className="article-section-heading">{section.heading}</h3>
              <ul className="article-section-list">
                {section.items.map((item, j) => (
                  <li key={j} className="article-section-item">{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Link to="/news" className="article-back">← BACK TO NEWS</Link>
      </div>

      {/* ── Footer ───────────────────────────────────────── */}
      <div className="site-footer-wrap">
        <img src={footerImg} alt="" className="blackfield-footer-img" />
        <div className="site-footer-overlay">
          <img src={logoV} alt="VISIONARY GAMES" className="footer-logo" />
          <span className="footer-credit">A OSADCHY YURI GAME</span>
          <img src={unityLogo} alt="Made with Unity" className="footer-unity-img" />
        </div>
      </div>

    </div>
  );
}
